<template>
  <section
    id="titlebar"
    class="titlebar"
    :title="title_data && title_data.title"
    :style="{
      color: title_data && title_data.color,
      backgroundColor: title_data && title_data.backgroundColor,
    }"
  >
    <span
      class="back btn"
      @click="go_back"
      :style="{ background: title_data && title_data.maskColor }"
    ></span>
    <div
      class="right-part"
      :style="title_data.right"
      v-if="$slots['title-bar-right-part']"
    >
      <slot name="title-bar-right-part"></slot>
    </div>
  </section>
</template>

<script>
/* eslint max-len:0 */
import amapApp from '@ali/amap-lib';
/*
 * 父组件需传入 title_data
 *   title_data:{
 *       title:'titlebar标题',
 *       backgroundColor:'#fff', //titlebar 背景颜色 不传默认为#fff
 *       color:'#000', // titlebar 文案颜色 不传默认为#000
 *       maskColor:'#ffffff' // 返回按钮颜色 不传默认为#000
 *   }
 * */
export default {
  // props: ['title_data'],
  props: {
    title_data: {
      type: Object,
      default: () => ({})
    },
    /**
     * 是不是需要自定义
     */
    customBackAction: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    immersiveHeight() {
      return this.$root.immersiveHeight;
    }
  },
  mounted() {
    if (this.immersiveHeight) document.getElementById('titlebar').style.paddingTop = `${this.immersiveHeight}px`;
    console.log('titlebar mounted');
  },
  methods: {
    go_back() {
      if (this.customBackAction) {
        this.$emit('goBack');
      } else {
        amapApp.native.webviewGoBack();
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../css/common-mixin";
.ios .titlebar {
  padding-top: rpx(40);
}
/*适配iPhone X ,iphone Xr ,iphone XS*/
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3),
  only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2),
  only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3),
  /* 适配iPhone 12 MINI */ only screen and (device-width: 360px) and (device-height: 780px) and (-webkit-device-pixel-ratio: 3),
  /* 适配iPhone 12&& 12pro */ only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3),
  /* 适配iPhone 12pro MAX */ only screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) {
  .ios .titlebar {
    padding-top: rpx(88);
  }
}

.titlebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  width: 100vw;
  height: rpx(96);
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  z-index: 99;
  color: #000;
  background: #fbfbfb;
  text-align: center;
  // transition: all 0.6s;
  // box-shadow: 0 1px 0 rgba(204, 204, 204, 0.5);
  &:before {
    content: attr(title);
    height: 100%;
    line-height: rpx(96);
    font-size: rpx(36);
    color: #000;
    /*font-weight: bold;*/
  }
  .btn {
    position: absolute;
    bottom: 0;
    width: rpx(96);
    height: rpx(96);
    &.back {
      left: 0;
      background: #000000;
      background-size: 100% 100%;
      -webkit-mask: url("../../assets/common/back.png") no-repeat;
      mask: url("../../assets/common/back.png") no-repeat;
      -webkit-mask-size: 100% 100%;
      mask-size: 100% 100%;
    }
  }
}
</style>
